import { render, staticRenderFns } from "./addPublish.vue?vue&type=template&id=8d4ce764"
import script from "./addPublish.vue?vue&type=script&lang=js"
export * from "./addPublish.vue?vue&type=script&lang=js"
import style0 from "./addPublish.vue?vue&type=style&index=0&id=8d4ce764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports